import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './navrhAktuEuListRow.scss';
import NavrhAktuEuListItem from '../../../model/NavrhAktuEuListItem';
import routes from '../../../routing/routes';
import mapDate from '../../../function/mapDate';

interface Props {
  aktEu: NavrhAktuEuListItem;
}

const NavrhAktuEuListRow = ({
  aktEu,
}: Props): ReactElement => aktEu && (
<div className="akt-eu-list-row">
  <Row>
    <Col width="one-third" className="akt-eu-list-column__third">
      Identifikátor aktu
    </Col>
    <Col width="one-third" className="akt-eu-list-column__third">
      Dátum prijatia
    </Col>
    <Col width="one-third" className="akt-eu-list-column__third">
      Inštitúcia
    </Col>
  </Row>
  <Row className="row-container-akt-eu-values">
    <Col width="one-third" className="akt-eu-list-column__third">
      <Text type="div" bold>
        {aktEu.identifikatorAktu ? aktEu.identifikatorAktu : 'Neuvedený'}
      </Text>
    </Col>
    <Col width="one-third" className="akt-eu-list-column__third">
      <Text type="div" bold>
        {aktEu.datumPrijatiaAktu ? mapDate(aktEu.datumPrijatiaAktu) : 'Neuvedený'}
      </Text>
    </Col>
    <Col width="one-third" className="akt-eu-list-column__third">
      <Text type="div" bold>
        {(aktEu.institucia && aktEu.institucia?.nazov !== '') ? aktEu.institucia?.nazov : 'Neuvedená'}
      </Text>
    </Col>
  </Row>
  <Row className="nazov-link-container">
    <Col width="full">
      <Link
        className="nazov-link"
        to={routes.navrhyAktovEu.detail.withParams(aktEu.uuid)}
      >
        {aktEu.nazovAktu ? aktEu.nazovAktu : 'Neuvedený'}
      </Link>
    </Col>
  </Row>
  <Row>
    <Col width="full">
      <Text
        type="span"
      >{aktEu.nazovLegislativnehoMaterialu}
      </Text>
    </Col>
  </Row>
</div>
);

export default NavrhAktuEuListRow;
